import { render, staticRenderFns } from "./edit.chats.page.vue?vue&type=template&id=4912a978&"
import script from "./edit.chats.page.vue?vue&type=script&lang=js&"
export * from "./edit.chats.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports